<template>
  <div class="flex flex-col" :class="size">
    <slot name="label">
      <label :for="props.name" :class="props.classes">{{ label }}</label>
    </slot>
    <slot>
      <Select
        :name="props.name"
        :id="props.name"
        type="text"
        :options="options"
        :optionLabel="optionsLabel"
        :placeholder="placeholder"
        :showClear="showClear"
        :disabled="disabled"
        v-model="value"
        class="h-10"
        @change="$emit('change')"
      ></Select>
      <small v-if="errorMessage" :id="props.name + '-help'" class="text-danger-500">{{ errorMessage }}</small>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";

interface Props {
  name: string;
  value?: string;
  label: string;
  size?: string;
  classes?: string;
  options: any[];
  optionsLabel: string | ((data: any) => string);
  placeholder?: string | undefined;
  showClear?: boolean;
  disabled?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  size: "w-full",
  classes: "font-bold",
  placeholder: " ",
  showClear: false,
  disabled: false,
});

const emit = defineEmits<{
  change: [];
}>();

const { value, errorMessage } = useField<Object>(() => props.name);
</script>
